import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {ServerGetSchema} from '../../../../api/DBSchema/Server';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import {dateAndTimeToString} from '../../../../utils/utils';
import SMCButton from '../../../../components/Simple/SMCButton';

const pageSchema = ServerGetSchema.pages.managedModules;
const pageId = pageSchema.pageId;

function ServerManagedModules({
    serverObject,
    reloadButtonOnClick
}) {
    const { t } = useTranslation();

    const pageData = serverObject[pageId];

    const dataList        = pageData[pageSchema.dataList];
    const sampleTimestamp = pageData[pageSchema.sampleTimestamp];

    const dataListSchema  = pageSchema.dataListSchema;

    return (
        <EditorLayout>
            <SMCTable
                columns={[
                    {id: 'process_name',      header: t('SMP.SMP_SERVERS.PAGE.PROCESS_NAME'), accessor: dataListSchema.processName,          width: 100, align: 'center' },
                    {id: 'status',            header: t('SMP.SMP_SERVERS.PAGE.STATUS'),       accessor: dataListSchema.status,               width: 80, align: 'center' },
                    {id: 'memory_usage',      header: t('SMP.SMP_SERVERS.PAGE.MEM_USAGE'),    accessor: dataListSchema.processMemoryUsage,   width: 80,  align: 'center' },
                    {id: 'cpu_usage',         header: t('SMP.SMP_SERVERS.PAGE.CPU_USAGE'),    accessor: dataListSchema.processCPUPercentage, width: 60,  align: 'center' },
                    {id: 'status_desription', header: t('SMP.SMP_SERVERS.PAGE.STATUS_DESC'),  accessor: dataListSchema.statusDescription,    width: 100, align: 'center' }
                ]}
                content={dataList}
                hasCheckboxColumn={false}
            />
            <SMCButton style={{ marginTop: '6px' }} onClick={reloadButtonOnClick} ignoreDisabledContext>{t('SMC_SERVERS_REFRESH_SRV')}</SMCButton>
            <Sepperator />
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(sampleTimestamp, true)}
                label={t('SMP.SMP_SERVERS.PAGE.LAST_MONITOR_SAMPLE')}
            />
        </EditorLayout>
    )
}

export default ServerManagedModules;